"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Drawer_1 = require("../../atoms/_Drawer/Drawer");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");

var ProcessHeader_1 = require("../ProcessHeader"); // TODO Keep in sync with Drawer


var Layout;

(function (Layout) {
  Layout["LEFT"] = "lsg--drawer__layer lsg--drawer__left";
  Layout["RIGHT"] = "lsg--drawer__layer lsg--drawer__right";
  Layout["FULL"] = "lsg--drawer__layer lsg--drawer__full";
})(Layout || (Layout = {}));

var Layer = function Layer(_a) {
  var children = _a.children,
      fromLeft = _a.fromLeft,
      onCloseClick = _a.onCloseClick,
      closeLinkLabel = _a.closeLinkLabel,
      drawerProps = __rest(_a, ["children", "fromLeft", "onCloseClick", "closeLinkLabel"]); // deal with deprecation


  var layout = drawerProps.layout || Layout.RIGHT;

  if (fromLeft === true) {
    layout = Layout.LEFT;
  } else if (fromLeft === false) {
    layout = Layout.RIGHT;
  }

  return React.createElement(Drawer_1.Drawer, __assign({}, drawerProps, {
    onCloseClick: onCloseClick,
    className: CSSPrefix_1.lsgPre + "layer",
    layout: layout
  }), React.createElement(ProcessHeader_1.ProcessHeader, null, React.createElement(IconLink_1.IconLink, {
    iconName: Icon_1.Icon.Names.interaction_arrows_chevronLeft,
    onClick: onCloseClick
  }, closeLinkLabel)), React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "layer-content"
  }, children));
};

exports.Layer = Layer;
Layer.displayName = "Layer";
Layer.Layout = Layout;